export default "__VITE_ASSET__e2ff41ed__"